module.exports = __webpack_public_path__ + "img/Funnelish Plus.3b72a445.svg";